import { defineMessages } from 'react-intl';

export const bookingConfirmationViewMessages = defineMessages({
  title: {
    id: 'a1j3Pf',
    description: 'Title of the freight booking confirmation drawer',
    defaultMessage: 'Shipment Booked',
  },
  getHelpReferenceLabel: {
    id: 'FaQCqS',
    description: 'Label for the PRO/BOL number reference shown in the Get Help modal',
    defaultMessage: 'PRO/BOL Number',
  },
  trackButton: {
    id: '94rEr/',
    description: 'Label for the track shipment button in the booking confirmation nav bar',
    defaultMessage: 'Track Shipment',
  },
  closeButton: {
    id: 'eoUyPE',
    description: 'Label for the close button in the booking confirmation drawer',
    defaultMessage: 'Close',
  },
  shareSuccess: {
    id: 'FQc/qM',
    description: 'Success notification shown after freight documents are emailed to recipients',
    defaultMessage: 'Documents shared successfully',
  },
  shareError: {
    id: 'n3cpyS',
    description: 'Error notification shown when sharing freight documents via email fails',
    defaultMessage: 'Failed to share documents. Please try again.',
  },
  sharePartialError: {
    id: 'pPUQrt',
    description: 'Error notification shown when some but not all recipients failed to receive the freight documents',
    defaultMessage: '{failedCount} of {totalCount} recipients failed. Please re-send to those addresses.',
  },
});
